import { Skeleton } from "../ui/skeleton";

export const CarCutterWebPlayerLoading = () => {
  return (
    <>
      <Skeleton className="hidden h-full min-h-60 w-full rounded-xl xl:block" />
      <Skeleton className="h-14 w-full rounded-xl xl:hidden" />
    </>
  );
};
